import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";

import {useStatusPagePdfDownload} from "../hooks/useStatusPagePdfDownload.ts";

interface DownloadReportButtonProps {
  mode: "public" | "private";
  slug: string;
  pageId: number | undefined;
  // Formatted "yyyyMMdd" range currently shown on the page — the report covers this range.
  startDate: string;
  endDate: string;
  defaultHistoryDateRange?: number;
  className?: string;
}

export const DownloadReportButton = ({
  mode,
  slug,
  pageId,
  startDate,
  endDate,
  defaultHistoryDateRange = 7,
  className,
}: DownloadReportButtonProps) => {
  const {downloadPdf, loading} = useStatusPagePdfDownload({mode, slug, pageId, defaultHistoryDateRange});

  return (
    <DropdownButton title="Download" variant="inputField" size="small" disabled={loading} className={className}>
      <DropdownItem onClick={() => downloadPdf({startDate, endDate})}>Download PDF</DropdownItem>
    </DropdownButton>
  );
};
